<ng-container *ngIf="structure['child']">
    <app-generic [structure]="structure"></app-generic>
</ng-container>
